import React from 'react';
import { Flex } from 'antd';
import { Contact } from '../types';
import styles from './ContactViewForm.module.css';
import CugBadge from './CugBadge';

interface ContactViewFormProps {
  contact: Contact;
}

const ContactViewForm: React.FC<ContactViewFormProps> = ({ contact }) => {
  const isCUG = contact.mobile1CUG === 'True';
  const mobile1Value = contact.mobile1 || 'N/A';
  const mobile1Display =
    mobile1Value !== 'N/A' ? (
      <CugBadge mobile={mobile1Value} isCUG={isCUG} />
    ) : (
      'N/A'
    );

  const fieldItems = [
    { label: 'Employee Number', value: contact.empNumber },
    { label: 'Employee Name', value: contact.empName },
    { label: 'Occupation', value: contact.occupation },
    { label: 'Employee Type', value: contact.empType },
    { label: 'Email', value: contact.email1 || 'N/A' },
    { label: 'Mobile', value: mobile1Display },
    { label: 'Extension', value: contact.extension || 'N/A' },
    { label: 'TA Number', value: contact.tanumber || 'N/A' },
  ];

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldItems.map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          <span className={styles.viewItemValue}>{item.value}</span>
        </div>
      ))}
    </Flex>
  );
};

export default ContactViewForm;
